import generateIcon from "../generateIcon";

const Calendar = generateIcon("fas fa-calendar-alt");

export default Calendar;